import { render, staticRenderFns } from "./UserBetsHistory.vue?vue&type=template&id=425b242c&"
import script from "./UserBetsHistory.vue?vue&type=script&lang=js&"
export * from "./UserBetsHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserBetsHistory.vue?vue&type=style&index=0&id=425b242c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports